import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useTranslation } from 'react-i18next';

export default function CheckoutSteps(props) {
  const { t } = useTranslation();

  return (
    <Row className="checkout-steps">
      {/* depending on wich props (step1, step2, step3, step4) the CheckoutSteps component gets passed, the corresponding Col(umns) get displayed as active. The 'checkout-steps' and its 'acitve' css class are managed in index.css */}
      <Col className={props.step1 ? 'active' : ''}>
        {t('checkout-steps-signin')}
      </Col>
      <Col className={props.step2 ? 'active' : ''}>
        {t('checkout-steps-shipping-address')}
      </Col>
      <Col className={props.step3 ? 'active' : ''}>
        {t('checkout-steps-payment')}
      </Col>
      <Col className={props.step4 ? 'active' : ''}>
        {t('checkout-steps-place-order')}
      </Col>
    </Row>
  );
}
